export default __webpack_public_path__ + "static/media/shieldstrike.9371aebf.png";